import React from "react";
// import { Link } from 'react-router-dom'
// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Greeting from './greeting.js';



const Error = () => {
  return (
    <section className='section'>
    

     <div className='container-2'> 
      <h1>404</h1>
      <h1>This is an Error Page.</h1>
      <h1>Route does not Exist.</h1>
      <h1>Please check URL.</h1>
        
     </div>
      
    </section>
   
  );
};

export default Error;
